import React, { PropTypes } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import moment from 'moment';

import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { branchShape } from '@bibliocommons/bc-prop-types';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ItemList from '../../../shared/ItemList';
import BatchActionsListContainer from '../../../../containers/shared/BatchActions/BatchActionsListContainer';
import BatchActionsListItem from '../../../shared/BatchActions/BatchActionsListItem';
import HoldItem from '../HoldItem';
import renderAddToShelfBatchActions from '../../shared/AddToShelfBatchActions';
import EditHoldDatesBatchActions from '../EditHoldDatesBatchActions';
import PauseHoldsBatchActions from '../PauseHoldsBatchActions';
import renderHoldsBatchActionsOptions from '../HoldsBatchActionOptions';
import BatchCancelOverlay from '../BatchCancelOverlay';

const isStartDateEditable = (hold) =>
  hold.getIn(['bib', 'policy', 'materialPolicy', 'supportsSuspendHoldStartDate'], false);

const isEndDateEditable = (hold) =>
  hold.getIn(['bib', 'policy', 'materialPolicy', 'supportsSuspendHoldEndDateEdit'], false);

export class HoldsList extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      showEditHoldsDateOverlay: false,
      showPauseHoldsDateOverlay: false,
      showBatchCancelOverlay: false
    };

    this.bindAll(
      'renderBibListItem',
      'renderBatchActionsMenu',
      'handleCloseEditHoldsDateOverlay',
      'handleClosePauseHoldsDateOverlay',
      'handleOpenBatchCancelOverlay',
      'handleCloseBatchCancelOverlay',
      'handleUpdateHoldsPauseEndDate',
      'handleUpdateHoldsExpiryDate'
    );
  }

  handleCloseEditHoldsDateOverlay() {
    this.setState({
      showEditHoldsDateOverlay: false
    });
  }

  handleOpenBatchCancelOverlay() {
    this.setState({ showBatchCancelOverlay: true });
  }

  handleCloseBatchCancelOverlay() {
    this.setState({ showBatchCancelOverlay: false });
  }

  handleUpdateHoldsPauseEndDate(holdIds, endDate) {
    const { accountId, holdActions, intl } = this.props;
    holdActions.updateHoldsPauseEndDate({
      accountId,
      holdIds,
      endDate,
      formattedEndDate: intl.formatDate(moment(endDate).toDate(), { year: 'numeric', day: '2-digit', month: 'short' })
    });
  }

  handleUpdateHoldsExpiryDate(holdIds, expiryDate) {
    const { accountId, holdActions, intl } = this.props;
    holdActions.updateHoldsExpiryDate({
      accountId,
      holdIds,
      expiryDate,
      formattedExpiryDate: intl.formatDate(moment(expiryDate).toDate(), { year: 'numeric', day: '2-digit', month: 'short' })
    });
  }

  anyHoldCancelling() {
    return this.props.holdsTransactions.toList().some(item => item.get('isCancelling', false));
  }


  anyActionInProgressForItem(item) {
    const { holdsTransactions, shelfTransactions } = this.props;
    const holdsId = item.get('holdsId');
    const metadataId = item.get('metadataId');

    const anyOngoingHoldsAction = !holdsTransactions.get(holdsId, Immutable.Map()).isEmpty();
    const anyOngoingShelfAction = !shelfTransactions.get(metadataId, Immutable.Map()).isEmpty();

    return anyOngoingHoldsAction || anyOngoingShelfAction;
  }

  batchActionsLoading() {
    return this.props.items.some(item => this.anyActionInProgressForItem(item));
  }

  handleClosePauseHoldsDateOverlay() {
    this.setState({
      showPauseHoldsDateOverlay: false
    });
  }

  renderBibListItem(item, selectedItems, updateItem) {
    const { branches, holdActions, workflowActions, availabilityDetailActions, accountId } = this.props;

    const actionItem = Immutable.Map({
      id: item.get('holdsId'),
      metadataId: item.getIn(['bib', 'briefInfo', 'metadataId']),
      actions: item.get('actions', Immutable.List())
    });

    return (
      <BatchActionsListItem
        key={item.get('holdsId')}
        actionItem={actionItem}
        selectedItems={selectedItems}
        updateItem={updateItem}>
        <HoldItem
          actionInProgress={this.anyActionInProgressForItem(item)}
          item={item}
          accountId={accountId}
          branches={branches}
          holdActions={holdActions}
          workflowActions={workflowActions}
          availabilityDetailActions={availabilityDetailActions}
          handleUpdateHoldsPauseEndDate={this.handleUpdateHoldsPauseEndDate}
          handleUpdateHoldsExpiryDate={this.handleUpdateHoldsExpiryDate}
          holdsTransactions={this.props.holdsTransactions}
          shelfTransactions={this.props.shelfTransactions} />
      </BatchActionsListItem>
    );
  }

  renderBatchEditHoldDatesOverlay(selectedItems) {
    const { accountId } = this.props;
    const canEditHoldDateItems = selectedItems.filter((item) => item.get('actions').includes('updateSuspend'));
    const metadataIds = canEditHoldDateItems.map(item => item.get('metadataId'));
    const selectedHolds = this.props.items.filter((item) => metadataIds.includes(item.getIn(['bib', 'id'])));
    const editableHolds = selectedHolds.filter(hold => (isStartDateEditable(hold) || isEndDateEditable(hold)));

    return (
      <EditHoldDatesBatchActions
        key="batch-edit-dates"
        open={this.state.showEditHoldsDateOverlay}
        accountId={accountId}
        items={editableHolds}
        handleUpdateHoldsPauseEndDate={this.handleUpdateHoldsPauseEndDate}
        handleClose={this.handleCloseEditHoldsDateOverlay} />
    );
  }

  renderBatchPauseHoldDatesOverlay(selectedItems) {
    const { accountId, holdActions } = this.props;
    const canPauseHoldItems = selectedItems
      .filter((item) => item.get('actions').includes('suspend') && !item.get('actions').includes('activate') && !item.get('actions').includes('updateSuspend'));


    const metadataIds = canPauseHoldItems.map(item => item.get('metadataId'));
    const selectedHolds = this.props.items.filter((item) => metadataIds.includes(item.getIn(['bib', 'id'])));

    const supportsSuspendHoldStartDate = selectedHolds.some(isStartDateEditable);
    const supportsSuspendHoldEndDate = selectedHolds.some(isEndDateEditable);

    return (
      <PauseHoldsBatchActions
        open={this.state.showPauseHoldsDateOverlay}
        accountId={accountId}
        items={canPauseHoldItems}
        supportsSuspendHoldStartDate={supportsSuspendHoldStartDate}
        supportsSuspendHoldEndDate={supportsSuspendHoldEndDate}
        handlePauseHolds={holdActions.pauseOrResumeHolds}
        handleClose={this.handleClosePauseHoldsDateOverlay} />
    );
  }

  renderBatchCancelOverlay(selectedItems) {
    const { accountId } = this.props;
    const canAddAnyItemToShelf = !selectedItems
      .filter((item) => item.get('actions').includes('addToShelf'))
      .isEmpty();

    return (
      <BatchCancelOverlay
        open={this.state.showBatchCancelOverlay}
        accountId={accountId}
        count={selectedItems.size}
        showShelfControls={canAddAnyItemToShelf}
        handleBatchCancel={({ shelfState }) => this.props.handleBatchCancel({ shelfState, items: selectedItems })}
        isLoading={this.anyHoldCancelling()}
        handleClose={this.handleCloseBatchCancelOverlay} />
    );
  }

  renderBatchActionsMenu(selectedActionItems) {
    const { handleOpenBatchCancelOverlay } = this;
    return [
      ...renderHoldsBatchActionsOptions({
        items: selectedActionItems,
        itemsWithBibs: this.props.items,
        handlePauseHoldsOverlay: () => this.setState({ showPauseHoldsDateOverlay: true }),
        handleEditHoldsOverlay: () => this.setState({ showEditHoldsDateOverlay: true }),
        handleResumeHolds: this.props.handleBatchResumeHolds,
        handleOpenBatchCancelOverlay
      }),
      ...renderAddToShelfBatchActions({
        items: selectedActionItems,
        handleBatchAddToShelf: this.props.handleBatchAddToShelf
      })
    ];
  }


  render() {
    return (
      <div className="cp-holds-list">
        <BatchActionsListContainer
          actionIsLoading={this.batchActionsLoading()}
          list={this.props.actionList}
          totalItems={this.props.totalCount}
          renderActionsMenu={this.renderBatchActionsMenu}>
          {(selectedItems, updateItem) => (
            <ItemList>
              {this.props.items.map(item => this.renderBibListItem(item, selectedItems, updateItem))}
              {this.renderBatchEditHoldDatesOverlay(selectedItems)}
              {this.renderBatchPauseHoldDatesOverlay(selectedItems)}
              {this.renderBatchCancelOverlay(selectedItems)}
            </ItemList>
          )}
        </BatchActionsListContainer>
      </div>
    );
  }
}

HoldsList.propTypes = {
  accountId: PropTypes.number,
  items: ImmutablePropTypes.list,
  totalCount: PropTypes.number,
  branches: ImmutablePropTypes.listOf(branchShape).isRequired,
  actionList: ImmutablePropTypes.list,
  holdsTransactions: ImmutablePropTypes.map,
  shelfTransactions: ImmutablePropTypes.map,
  workflowActions: PropTypes.objectOf(PropTypes.func),
  holdActions: PropTypes.objectOf(PropTypes.func),
  renderBatchActionButtons: PropTypes.func,
  handleBatchAddToShelf: PropTypes.func,
  intl: intlShape
};

export default injectIntl(HoldsList);



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsList/HoldsList.jsx